import { apiDate, optional, string, uuid, zenum, zodLess, ZodLessInfer, zunion } from '@kaiizen/zod-less';
import { ApiUserOrgRoleSchema } from './RecordTypes/ApiUserOrgSchema';
import { optionalApiDate } from './schemaLib';

export const API_KEY_DEFAULT_EXPIRATION_DAYS = 90;
export const API_KEY_MAXIMUM_EXPIRATION_DAYS = 365;
export const API_KEY_MINIMUM_EXPIRATION_MS = 60 * 60 * 1000;
export const API_KEY_MAXIMUM_EXPIRATION_MS = API_KEY_MAXIMUM_EXPIRATION_DAYS * 24 * 60 * 60 * 1000;

export const ApiApiKeyStatusSchema = zenum('active', 'expired', 'revoked');
export type ApiApiKeyStatus = ZodLessInfer<typeof ApiApiKeyStatusSchema>;

export const ApiApiKeyRoleSchema = zodLess('manager|fieldUser|viewer');
export type ApiApiKeyRole = ZodLessInfer<typeof ApiApiKeyRoleSchema>;
export const ApiApiKeyRoles: readonly ApiApiKeyRole[] = ApiApiKeyRoleSchema.options;

/** Non-secret API-key metadata that may safely be listed and displayed. */
export const ApiApiKeySchema = zodLess({
  id: uuid,
  userId: uuid,
  name: string,
  role: ApiUserOrgRoleSchema,
  createdAt: apiDate,
  expiresAt: apiDate,
  revokedAt: optionalApiDate,
  lastUsedAt: optionalApiDate,
  status: ApiApiKeyStatusSchema,
}, { ref: 'apiKey' });
export type ApiApiKey = ZodLessInfer<typeof ApiApiKeySchema>;

export const ApiCreateApiKeySchema = zunion(
  zodLess({
    name: string,
    role: ApiApiKeyRoleSchema,
    expiresAt: optional(apiDate),
  }).strict(),
  zodLess({
    machineUserId: uuid,
    expiresAt: optional(apiDate),
  }).strict(),
).meta({
  override: ({ jsonSchema }: { jsonSchema: { anyOf?: unknown; oneOf?: unknown } }) => {
    jsonSchema.oneOf = jsonSchema.anyOf;
    delete jsonSchema.anyOf;
  },
});
export type ApiCreateApiKey = ZodLessInfer<typeof ApiCreateApiKeySchema>;

export const ApiCreateApiKeyResponseSchema = zodLess({
  apiKey: ApiApiKeySchema,
  rawKey: string,
});
export type ApiCreateApiKeyResponse = ZodLessInfer<typeof ApiCreateApiKeyResponseSchema>;

export const ApiUpdateApiKeySchema = zodLess({
  name: optional(string),
  role: optional(ApiApiKeyRoleSchema),
});
export type ApiUpdateApiKey = ZodLessInfer<typeof ApiUpdateApiKeySchema>;

export const getApiKeysQueryKeyPrefix = () => 'apiKeys';
export const getApiKeysQueryKey = () => getApiKeysQueryKeyPrefix();
